import * as PIXI from "pixi.js";
import HowToPlayLayer from "../../layers/HowToPlayLayer";

import HowToPlayText from "./firstPart/TextOfHowToPlay";
import RedArrow from "./firstPart/RedArrow";
import WinningElmInfo from "./firstPart/WinningElmInfo";
import ClickAnyWhereText from "./firstPart/ClickAnyWhereText";

import HTPTextAnimation from "../../animations/HTPTextAnimation";
import HTPRedArrowAnimation from "../../animations/HTPRedArrowAnimation";
import HTPWElmInfoAnimation from "../../animations/HTPWElmInfoAnimation";
import HTPClickAnyAnimation from "../../animations/HTPClickAnyAnimation";

import { EventBus, EnumEventBus } from "../../managers/EventBus";

export default class HTPFirstPart extends PIXI.Container {
  static instance: HTPFirstPart;
  private HowToPlayLayer = HowToPlayLayer.getInstance();
  private EventBus = EventBus;
  private RedArrow: RedArrow;
  private HTPText: HowToPlayText;
  private WElmInfo: WinningElmInfo;
  private clickAnyWhereText: ClickAnyWhereText;
  private isReversed: boolean = false;

  constructor() {
    super();
    if (!HTPFirstPart.instance) {
      HTPFirstPart.instance = this;
    }
    this.RedArrow = new RedArrow();
    this.HTPText = new HowToPlayText();
    this.WElmInfo = new WinningElmInfo();
    this.clickAnyWhereText = new ClickAnyWhereText();

    this.addToLayer();
  }

  hideElms() {
    [this.RedArrow, this.HTPText, this.WElmInfo, this.clickAnyWhereText].forEach(e => {
      e.visible = false;
    })
  }


  runAnimations() {
    this.isReversed = false;
    this.RedArrow.visible = false;
    this.clickAnyWhereText.visible = false;
    this.WElmInfo.visible = false;
    this.HTPText.visible = false;
    this.clickAnyWhereText.scale.set(this.clickAnyWhereText.startScale);
    this.WElmInfo.scale.set(this.WElmInfo.startScale);
    this.RedArrow.y = this.RedArrow.startY;
    this.HTPText.scale.set(this.HTPText.startScale);

    this.EventBus.emit(EnumEventBus.setHFType, "2");
    this.HTPText.visible = true;
    new HTPTextAnimation(this.HTPText, 1, () => {
      if (this.isReversed) {
        return
      }
      this.RedArrow.visible = true;
      new HTPRedArrowAnimation(this.RedArrow, this.RedArrow.targetY, () => {
        if (this.isReversed) {
          return
        }
        this.WElmInfo.visible = true;
        new HTPWElmInfoAnimation(this.WElmInfo, 1, () => {
          if (this.isReversed) {
            return
          }
          this.clickAnyWhereText.visible = true;
          new HTPClickAnyAnimation(this.clickAnyWhereText, 1, () => {
          });
        })
      });
    })
  }

  runReverseAnimations(cb: () => void) {
    this.isReversed = true;
    this.RedArrow.visible = false;
    this.clickAnyWhereText.visible = false;
    this.WElmInfo.visible = false;
    this.HTPText.visible = false;
    cb();
  }
  addToLayer() {
    this.HowToPlayLayer.addChild(this);
  }

  static getInstance() {
    return HTPFirstPart.instance;
  }
}